import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Text, Button } from '@spothero/ui';
import IconInfo from '@spothero/icons/info-circle-filled';
import AlertModal from 'common/alert-modal';
import dayjs from 'utils/dayjs-duration';
const CANCELLATION_NOT_ALLOWED = 'no';
const CancellationInfo = ({ cancellationAllowed, eventCancellationMinutes = 0, canCancelHPEReservation = false, }) => {
    const { starts } = useSelector((state) => state.searchRequest);
    const [showModal, setShowModal] = useState(false);
    const toggleAlertModal = () => setShowModal(prevShowModal => !prevShowModal);
    const cancellationCutOffTime = dayjs(starts).subtract(eventCancellationMinutes, 'minute');
    const canCancel = cancellationAllowed !== CANCELLATION_NOT_ALLOWED &&
        eventCancellationMinutes > 0
        ? canCancelHPEReservation
        : cancellationAllowed !== CANCELLATION_NOT_ALLOWED;
    if (eventCancellationMinutes > 0) {
        if (canCancel) {
            return (<Text fontSize="xs" lineHeight={1.3}>
                    Cancel until {dayjs(cancellationCutOffTime).format('MMM D')}{' '}
                    at {dayjs(cancellationCutOffTime).format('h:mm a')}
                </Text>);
        }
        else {
            return (<Text color="red.default" fontSize="xs">
                    This reservation is non-refundable
                </Text>);
        }
    }
    if (canCancel) {
        return null;
    }
    return (<>
            <Button variant="tertiary" onClick={toggleAlertModal} rightIcon={<IconInfo height="10px" width="10px"/>} textTransform="auto">
                <Text color="red.default" fontSize="xs">
                    This reservation is non-refundable
                </Text>
            </Button>
            {showModal && (<AlertModal title="Cancellation" message="Due to rules set by the operator, this reservation is not cancellable. If you choose to cancel this reservation, you will not be refunded any of your payment. You may, however, adjust this reservation to a different time up until 24 hours of the start time of the reservation." onHidden={toggleAlertModal}/>)}
        </>);
};
export default CancellationInfo;
